export enum FavouriteState {
    Inactive = "inactive",
    Loading = "loading",
    Active = "active",
}
